
export const formDataType = {
    COLLAR_KI_KO: [
        {value: "nominal_du_pret",                  type: "number"},
        {value: "date_de_depart",                   type: "date"  },
        {value: "duree_du_pret_sous_jacent",        type: "string"},
        {value: "duree_de_la_couverture",           type: "string"},
        {value: "periodicite",                      type: "string"},
        {value: "date_de_premier_flux",             type: "date"  },
        {value: "amortissement",                    type: "string"},
        {value: "indice_sous_jacent",               type: "string"},
        {value: "spread",                           type: "number"},
        {value: "constatation_du_fixing",           type: "number"},
        {value: "type_de_fixing",                   type: "string"},
        {value: "calendrier",                       type: "string"},
        {value: "convention_de_calcul_interet",     type: "string"},
        {value: "convention_de_paiement",           type: "string"},
        {value: "strike_cap",                       type: "number"},
        {value: "strike_floor",                     type: "number"},
        {value: "strike_ko",                        type: "number"},
        {value: "strike_ki",                        type: "number"},
        {value: "nature_de_la_prime_de_couverture", type: "string"},
        {value: "prime_de_couverture",              type: "number"},
        {value: "marge",                            type: "string"}
    ],
    AUTOCALL_RENDEMENT: [
        {value: "support_investissement",                       type: "string"},
        {value: "nominal_cible",                                type: "number"},
        {value: "duree_du_placement",                           type: "string"},
        {value: "periodicite_des_coupons",                      type: "string"},
        {value: "sous_jacent",                                  type: "string"},
        {value: "seuil_autocall",                               type: "number"},
        {value: "coupon_conditionnel_maximum",                  type: "number"},
        {value: "coupon_conditionnel_minimum",                  type: "number"},
        {value: "barriere_de_coupon_conditionnel_minimum",      type: "number"},
        {value: "nombre_de_periodes_avec_un_coupon_garanti",    type: "number"},
        {value: "coupon_garanti",                               type: "number"},
        {value: "barriere_de_protection_du_capital",            type: "number"},
        {value: "commentaire",                                  type: "string"},
        {value: "marge",                                        type: "string"}
    ],
    WEDDING_CAKE_OPTIONS: [
            {value: "devise",               type: "string"  },
            {value: "sens",                 type: "string"  },
            {value: "montant_minimum",      type: "number"  },
            {value: "montant_maximum",      type: "number"  },
            {value: "strike_bonifie",       type: "number"  },
            {value: "strike_degrade",       type: "number"  },
            {value: "date_echeance",        type: "date"    },
            {value: "date_de_livraison",    type: "date"    },
            {value: "barriere_basse",       type: "number"  },
            {value: "barriere_haute",       type: "number"  },
            {value: "style_de_barriere",    type: "string"  },
            {value: "spot_de_reference",    type: "number"  },
            {value: "nombre_echeances",     type: "number"   },
            {value: "frequence_echeances",  type: "string"   },
            {value: "commentaire",          type: "string"  },
            {value: "cours_a_terme",        type: "number"  },
            {value: "prime_devise",         type: "number"  },
            {value: "marge",                type: "string"  }
    ],
    TUNNEL_ASYMETRIQUE: [
        {value: "devise",                   type: "string"  },
        {value: "sens",                     type: "string"  },
        {value: "montant_minimum",          type: "number"  },
        {value: "montant_maximum",          type: "number"  },
        {value: "strike_montant_minimum",   type: "number"  },
        {value: "strike_montant_maximum",   type: "number"  },
        {value: "date_echeance",            type: "date"    },
        {value: "date_de_livraison",        type: "date"    },
        {value: "nombre_echeances",         type: "number"   },
        {value: "frequence_echeances",      type: "string"   },
        {value: "spot_de_reference",        type: "number"  },
        {value: "commentaire",              type: "string"  },
        {value: "cours_a_terme",            type: "number"  },
        {value: "prime_devise",             type: "number"  },
        {value: "marge",                    type: "string"  },
    ],
    TERME_PARTICIPATIF: [
        {value: "devise",                       type: "string"  },
        {value: "sens",                         type: "string"  },
        {value: "montant_minimum",              type: "number"  },
        {value: "montant_maximum",              type: "number"  },
        {value: "strike",                       type: "number"  },
        {value: "ki",                           type: "number"  },
        {value: "style_de_barriere",            type: "string"  },
        {value: "date_de_debut_de_la_fenetre",  type: "date"    },
        {value: "date_de_fin_de_la_fenetre",    type: "date"    },
        {value: "date_echeance",                type: "date"    },
        {value: "date_de_livraison",            type: "date"    },
        {value: "nombre_echeances",             type: "number"   },
        {value: "frequence_echeances",          type: "string"   },
        {value: "spot_de_reference",            type: "number"  },
        {value: "cours_a_terme",                type: "number"  },
        {value: "prime_devise",                 type: "number"  },
        {value: "marge",                        type: "string"  },
        {value: "commentaire",                  type: "string"  },
    ],
    TERME_ASYMETRIQUE: [
        {value: "devise",               type: "string"  },
        {value: "sens",                 type: "string"  },
        {value: "montant_minimum",      type: "number"  },
        {value: "montant_maximum",      type: "number"  },
        {value: "strike",               type: "number"  },
        {value: "date_echeance",        type: "date"    },
        {value: "date_de_livraison",    type: "date"    },
        {value: "nombre_echeances",     type: "number"   },
        {value: "frequence_echeances",  type: "string"   },
        {value: "spot_de_reference",    type: "number"  },
        {value: "cours_a_terme",        type: "number"  },
        {value: "prime_devise",         type: "number"  },
        {value: "marge",                type: "string"  },
        {value: "commentaire",          type: "string"  },
    ],
    TERME_ASYMETRIQUE_DESACTIVANT: [
        {value: "devise",                       type: "string"  },
        {value: "sens",                         type: "string"  },
        {value: "montant_minimum",              type: "number"  },
        {value: "montant_maximum",              type: "number"  },
        {value: "strike",                       type: "number"  },
        {value: "ko",                           type: "number"  },
        {value: "style_de_barriere",            type: "string"  },
        {value: "date_de_debut_de_la_fenetre",  type: "date"    },
        {value: "date_de_fin_de_la_fenetre",    type: "date"    },
        {value: "date_echeance",                type: "date"    },
        {value: "date_de_livraison",            type: "date"    },
        {value: "nombre_echeances",             type: "number"   },
        {value: "frequence_echeances",          type: "string"   },
        {value: "spot_de_reference",            type: "number"  },
        {value: "cours_a_terme",                type: "number"  },
        {value: "prime_devise",                 type: "number"  },
        {value: "marge",                        type: "string"  },
        {value: "commentaire",                  type: "string"  },
    ],
    TERME_ACCUMULATEUR_KO: [
        {value: "devise",                    type: "string"   },
        {value: "sens",                      type: "string"   },
        {value: "montant_minimum",           type: "number"   },
        {value: "montant_maximum",           type: "number"   },
        {value: "strike",                    type: "number"   },
        {value: "ko",                        type: "number"   },
        {value: "borne_basse",               type: "number"   },
        {value: "borne_haute",               type: "number"   },
        {value: "nombre_de_fixings",         type: "number"   },
        {value: "frequence_fixings",         type: "string"   },
        {value: "premier_fixing",            type: "date"     },
        {value: "dernier_fixing",            type: "date"     },
        {value: "livraison",                 type: "string"   },
        {value: "date_echeance",             type: "date"     },
        {value: "date_de_livraison",         type: "date"     },
        {value: "nombre_echeances",          type: "number"   },
        {value: "frequence_echeances",       type: "string"   },
        {value: "spot_de_reference",         type: "number"   },
        {value: "cours_a_terme",             type: "number"   },
        {value: "prime_devise",              type: "number"   },
        {value: "marge",                     type: "string"   },
        {value: "commentaire",               type: "string"   }
    ],
    TARF: [
        {value: "devise",                    type: "string"   },
        {value: "sens",                      type: "string"   },
        {value: "montant_minimum",           type: "number"   },
        {value: "montant_maximum",           type: "number"   },
        {value: "strike",                    type: "number"   },
        {value: "nombre_de_fixings",         type: "number"   },
        {value: "frequence_fixings",         type: "string"   },
        {value: "premier_fixing",            type: "date"     },
        {value: "dernier_fixing",            type: "date"     },
        {value: "reserve_de_figure",         type: "number"   },
        {value: "date_echeance",             type: "date"     },
        {value: "date_de_livraison",         type: "date"     },
        {value: "nombre_echeances",          type: "number"   },
        {value: "frequence_echeances",       type: "string"   },
        {value: "spot_de_reference",         type: "number"   },
        {value: "cours_a_terme",             type: "number"   },
        {value: "prime_devise",              type: "number"   },
        {value: "marge",                     type: "string"   },
        {value: "commentaire",               type: "string"   }
    ],
    WEDDING_CAKE_ACCUMULATEUR: [
        {value: "devise",                    type: "string" },
        {value: "sens",                      type: "string" },
        {value: "montant_minimum",           type: "number" },
        {value: "montant_maximum",           type: "number" },
        {value: "strike_bonifie",            type: "number" },
        {value: "strike_degrade",            type: "number" },
        {value: "ko",                        type: "number" },
        {value: "borne_basse",               type: "number" },
        {value: "borne_haute",               type: "number" },
        {value: "nombre_de_fixings",         type: "number" },
        {value: "frequence_fixings",         type: "string" },
        {value: "premier_fixing",            type: "date"   },
        {value: "dernier_fixing",            type: "date"   },
        {value: "date_echeance",             type: "date"   },
        {value: "date_de_livraison",         type: "date"   },
        {value: "nombre_echeances",          type: "number" },
        {value: "frequence_echeances",       type: "string" },
        {value: "spot_de_reference",         type: "number" },
        {value: "cours_a_terme",             type: "number" },
        {value: "prime_devise",              type: "number" },
        {value: "marge",                     type: "string" },
        {value: "commentaire",               type: "string" }
    ],
    SWAP: [
        {value: "nominal_du_pret",                  type: "number"  },
        {value: "date_de_depart",                   type: "date"    },
        {value: "duree_du_pret_sous_jacent",        type: "string"  },
        {value: "duree_de_la_couverture",           type: "string"  },
        {value: "periodicite",                      type: "string"  },
        {value: "date_de_premier_flux",             type: "date"    },
        {value: "amortissement",                    type: "string"  },
        {value: "indice_sous_jacent",               type: "string"  },
        {value: "spread",                           type: "number"  },
        {value: "constatation_du_fixing",           type: "number"  },
        {value: "type_de_fixing",                   type: "string"  },
        {value: "calendrier",                       type: "string"  },
        {value: "convention_de_calcul_interet",     type: "string"  },
        {value: "convention_de_paiement",           type: "string"  },
        {value: "base",                             type: "string"  },
        {value: "taux_fixe",                        type: "number"  },
        {value: "nature_de_la_prime_de_couverture", type: "string"  },
        {value: "prime_de_couverture",              type: "number"  },
        {value: "marge",                            type: "string"  },
        {value: "commentaire",                      type: "string"  }
    ],
    CAP: [
        {value: "nominal_du_pret",                  type: "number"  },
        {value: "date_de_depart",                   type: "date"    },
        {value: "duree_du_pret_sous_jacent",        type: "string"  },
        {value: "duree_de_la_couverture",           type: "string"  },
        {value: "periodicite",                      type: "string"  },
        {value: "date_de_premier_flux",             type: "date"    },
        {value: "amortissement",                    type: "string"  },
        {value: "indice_sous_jacent",               type: "string"  },
        {value: "spread",                           type: "number"  },
        {value: "constatation_du_fixing",           type: "number"  },
        {value: "type_de_fixing",                   type: "string"  },
        {value: "calendrier",                       type: "string"  },
        {value: "convention_de_calcul_interet",     type: "string"  },
        {value: "convention_de_paiement",           type: "string"  },
        {value: "base",                             type: "string"  },
        {value: "strike_cap",                       type: "number"  },
        {value: "nature_de_la_prime_de_couverture", type: "string"  },
        {value: "prime_de_couverture",              type: "number"  },
        {value: "marge",                            type: "string"  },
        {value: "commentaire",                      type: "string"  }
    ],
    COLLAR: [
        {value: "nominal_du_pret",                  type: "number"  },
        {value: "date_de_depart",                   type: "date"    },
        {value: "duree_du_pret_sous_jacent",        type: "string"  },
        {value: "duree_de_la_couverture",           type: "string"  },
        {value: "periodicite",                      type: "string"  },
        {value: "date_de_premier_flux",             type: "date"    },
        {value: "amortissement",                    type: "string"  },
        {value: "indice_sous_jacent",               type: "string"  },
        {value: "spread",                           type: "number"  },
        {value: "constatation_du_fixing",           type: "number"  },
        {value: "type_de_fixing",                   type: "string"  },
        {value: "calendrier",                       type: "string"  },
        {value: "convention_de_calcul_interet",     type: "string"  },
        {value: "convention_de_paiement",           type: "string"  },
        {value: "base",                             type: "string"  },
        {value: "strike_cap",                       type: "number"  },
        {value: "strike_floor",                     type: "number"  },
        {value: "nature_de_la_prime_de_couverture", type: "string"  },
        {value: "prime_de_couverture",              type: "number"  },
        {value: "marge",                            type: "string"  },
        {value: "commentaire",                      type: "string"  }
    ],
    SWAP_KO: [
        {value: "nominal_du_pret",                  type: "number"  },
        {value: "date_de_depart",                   type: "date"    },
        {value: "duree_du_pret_sous_jacent",        type: "string"  },
        {value: "duree_de_la_couverture",           type: "string"  },
        {value: "periodicite",                      type: "string"  },
        {value: "date_de_premier_flux",             type: "date"    },
        {value: "amortissement",                    type: "string"  },
        {value: "indice_sous_jacent",               type: "string"  },
        {value: "spread",                           type: "number"  },
        {value: "constatation_du_fixing",           type: "number"  },
        {value: "type_de_fixing",                   type: "string"  },
        {value: "calendrier",                       type: "string"  },
        {value: "convention_de_calcul_interet",     type: "string"  },
        {value: "convention_de_paiement",           type: "string"  },
        {value: "base",                             type: "string"  },
        {value: "strike_floor",                     type: "number"  },
        {value: "strike_ko",                        type: "number"  },
        {value: "nature_de_la_prime_de_couverture", type: "string"  },
        {value: "prime_de_couverture",              type: "number"  },
        {value: "marge",                            type: "string"  },
        {value: "commentaire",                      type: "string"  }
    ],
    CAP_KO: [
        {value: "nominal_du_pret",                  type: "number"  },
        {value: "date_de_depart",                   type: "date"    },
        {value: "duree_du_pret_sous_jacent",        type: "string"  },
        {value: "duree_de_la_couverture",           type: "string"  },
        {value: "periodicite",                      type: "string"  },
        {value: "date_de_premier_flux",             type: "date"    },
        {value: "amortissement",                    type: "string"  },
        {value: "indice_sous_jacent",               type: "string"  },
        {value: "spread",                           type: "number"  },
        {value: "constatation_du_fixing",           type: "number"  },
        {value: "type_de_fixing",                   type: "string"  },
        {value: "calendrier",                       type: "string"  },
        {value: "convention_de_calcul_interet",     type: "string"  },
        {value: "convention_de_paiement",           type: "string"  },
        {value: "base",                             type: "string"  },
        {value: "strike_cap",                       type: "number"  },
        {value: "strike_ko",                        type: "number"  },
        {value: "nature_de_la_prime_de_couverture", type: "string"  },
        {value: "prime_de_couverture",              type: "number"  },
        {value: "marge",                            type: "string"  },
        {value: "commentaire",                      type: "string"  }
    ],
    COLLAR_KO: [
        {value: "nominal_du_pret",                  type: "number"  },
        {value: "date_de_depart",                   type: "date"    },
        {value: "duree_du_pret_sous_jacent",        type: "string"  },
        {value: "duree_de_la_couverture",           type: "string"  },
        {value: "periodicite",                      type: "string"  },
        {value: "date_de_premier_flux",             type: "date"    },
        {value: "amortissement",                    type: "string"  },
        {value: "indice_sous_jacent",               type: "string"  },
        {value: "spread",                           type: "number"  },
        {value: "constatation_du_fixing",           type: "number"  },
        {value: "type_de_fixing",                   type: "string"  },
        {value: "calendrier",                       type: "string"  },
        {value: "convention_de_calcul_interet",     type: "string"  },
        {value: "convention_de_paiement",           type: "string"  },
        {value: "base",                             type: "string"  },
        {value: "strike_cap",                       type: "number"  },
        {value: "strike_floor",                     type: "number"  },
        {value: "strike_ko",                        type: "number"  },
        {value: "nature_de_la_prime_de_couverture", type: "string"  },
        {value: "prime_de_couverture",              type: "number"  },
        {value: "marge",                            type: "string"  },
        {value: "commentaire",                      type: "string"  }
    ],
    DIY_PLACEMENT: [
        {value: "support_investissement",                   type: "string"  },
        {value: "profil_du_produit",                        type: "string"  },
        {value: "nominal_cible",                            type: "number"  },
        {value: "duree_du_placement",                       type: "number"  },
        {value: "periodicite_des_coupons",                  type: "string"  },
        {value: "sous_jacent",                              type: "string"  },
        {value: "remboursement_conditionnel_avant_terme",   type: "boolean" },
        {value: "seuil_autocall",                           type: "number"  },
        {value: "coupon_cible",                             type: "number"  },
        {value: "coupon_minimum",                           type: "number"  },
        {value: "barriere_de_coupon_conditionnel_minimum",  type: "number"  },
        {value: "effet_memoire_de_coupon",                  type: "boolean" },
        {value: "garantie_en_capital",                      type: "boolean" },
        {value: "barriere_de_protection_du_capital",        type: "number"  },
        {value: "marge",                                    type: "string"  },
        {value: "commentaire",                              type: "string"  }
    ],
    DIY_CHANGE: [
        {value: "devise",                    type: "string" },
        {value: "sens",                      type: "string" },
        {value: "montant",                   type: "number" },
        {value: "montant_minimum",           type: "number" },
        {value: "montant_maximum",           type: "number" },
        {value: "strike_montant_minimum",    type: "number" },
        {value: "strike_montant_maximum",    type: "number" },
        {value: "date_echeance",             type: "date"   },
        {value: "date_de_livraison",         type: "date"   },
        {value: "strike",                    type: "number" },
        {value: "ki",                        type: "number" },
        {value: "ko",                        type: "number" },
        {value: "montant_minimum_fixings",   type: "number" },
        {value: "montant_maximum_fixings",   type: "number" },
        {value: "borne_basse",               type: "number" },
        {value: "borne_haute",               type: "number" },
        {value: "nombre_de_fixings",         type: "number" },
        {value: "frequence_fixings",         type: "string" },
        {value: "premier_fixing",            type: "date"   },
        {value: "dernier_fixing",            type: "date"   },
        {value: "livraison",                 type: "string" },
        {value: "reserve_de_figure",         type: "number" },
        {value: "barriere_basse",            type: "number" },
        {value: "barriere_haute",            type: "number" },
        {value: "style_de_barriere_basse",   type: "string" },
        {value: "style_de_barriere_haute",   type: "string" },
        {value: "nombre_echeances",          type: "number" },
        {value: "frequence_echeances",       type: "string" },
        {value: "spot_de_reference",         type: "number" },
        {value: "cours_a_terme",             type: "number" },
        {value: "prime_devise",              type: "number" },
        {value: "marge",                     type: "string" },
        {value: "commentaire",               type: "string" }
    ],
    TERME_SEC: [
        {value: "devise",                    type: "string" },
        {value: "sens",                      type: "string" },
        {value: "montant",                   type: "number" },
        {value: "date_de_livraison",         type: "date"   },
        {value: "spot_de_reference",         type: "number" },
        {value: "cours_a_terme",             type: "number" },
        {value: "points_de_terme",           type: "number" },
        {value: "marge",                     type: "string" },
        {value: "commentaire",               type: "string" }
    ]
}



// WEBPACK FOOTER //
// ./src/shared/Cotation/form/CotationData.tsx